import { FC } from "react"
import { SquareWrapper } from "~/contexts/SquareWrapper"
import { CheckoutEcomm } from "./CheckoutEcomm"

export const CheckoutEcommPage: FC = () => {
	return (
		<SquareWrapper>
			<CheckoutEcomm />
		</SquareWrapper>
	)
}

export default CheckoutEcommPage
